import Component from './components/PurchaseOrders';
import { PATH } from './constants';

export { PATH };
export default Component;
